import React from 'react'
import styled from '@emotion/styled'


const Section = styled.section`
  margin-bottom: 1.5rem;
`

const TermsConditions: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>
      
      <Section>
        <h2>1. Agreement to Terms</h2>
        <p>
          By accessing or using our app, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please refrain from using the app.
        </p>
      </Section>
      
      <Section>
        <h2>2. Use License</h2>
        <p>
          We grant you a limited, non-exclusive, and revocable license to use the app for personal, non-commercial purposes. You may not:
        </p>
        <ul>
          <li>Modify or copy the app's content.</li>
          <li>Use the app for any commercial purpose without prior written consent.</li>
          <li>Attempt to decompile or reverse-engineer any software associated with the app.</li>
          <li>Engage in activities that disrupt or harm the app's operation.</li>
        </ul>
        <p>
          This license will automatically terminate if you violate any of these restrictions.
        </p>
      </Section>
      
      <Section>
        <h2>3. User Obligations</h2>
        <p>
          As a user of the app, you agree to:
        </p>
        <ul>
          <li>Provide accurate and truthful information during registration or use of the app.</li>
          <li>Refrain from uploading inappropriate or offensive content, including photos.</li>
          <li>Use the app in compliance with applicable laws and regulations.</li>
        </ul>
      </Section>
      
      <Section>
        <h2>4. Intellectual Property</h2>
        <p>
          All content, trademarks, and software associated with the app are the property of the app's creators or licensors. Unauthorized use of the app's intellectual property is prohibited.
        </p>
      </Section>
      
      <Section>
        <h2>5. Disclaimer</h2>
        <p>
          The app is provided on an "as is" and "as available" basis. We do not guarantee that the app will be error-free or uninterrupted. The app is not a substitute for professional fitness or health advice.
        </p>
      </Section>
      
      <Section>
        <h2>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the app. This includes, but is not limited to, damages related to personal injury, loss of data, or interruption of service.
        </p>
      </Section>
      
      <Section>
        <h2>7. Termination</h2>
        <p>
          We reserve the right to terminate or suspend your access to the app at our sole discretion, without notice, for any reason, including a violation of these Terms and Conditions.
        </p>
      </Section>
      
      <Section>
        <h2>8. Changes to Terms</h2>
        <p>
          We may update these Terms and Conditions from time to time. Continued use of the app after such changes constitutes acceptance of the updated terms.
        </p>
      </Section>
      
      <Section>
        <h2>9. Governing Law</h2>
        <p>
          These Terms and Conditions are governed by and construed in accordance with the laws of the United States. Any disputes will be resolved exclusively in the courts of the United States.
        </p>
      </Section>
      
      <Section>
        <h2>10. Contact Us</h2>
        <p>
          If you have any questions or concerns about these Terms and Conditions, please contact us at co.enruta@gmail.com.
        </p>
      </Section>
    </div>
  );
}

export default TermsConditions 